import React from 'react';
import { BookingsTableData, BookingsApiModel, NON_EDITABLE_BOOKING_STATUSES } from './helpers';
import { CellProps } from 'react-table';
import TextInputCell from '../../../ui/Table/Cells/TextInputCell';

type PostLinkCellProps<T extends BookingsTableData> = CellProps<T> & {
    updateBooking?: (bookingId: number, data: BookingsApiModel) => Promise<void>;
};

const PostLinkCell = <T extends BookingsTableData>({ updateBooking, ...props }: PostLinkCellProps<T>) => {
    const { date_approved, status, id } = props.row.original;
    const disabled =
        Boolean(date_approved) || NON_EDITABLE_BOOKING_STATUSES.includes(status) || status === 'content_only';

    return (
        <TextInputCell
            {...props}
            placeholder="Enter post url"
            disabled={disabled}
            onSubmit={async (value) => {
                if (typeof updateBooking === 'function' && value !== props.value) {
                    await updateBooking(id, { post_url: value });
                }
            }}
        />
    );
};

export default PostLinkCell;
